'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import { RawHtml } from '../../../components/RawHtml/RawHtml';
import { StaticText } from '../i18n';
import { SingleProductPromotionAdditionalCampaign } from '../types';

interface CampaignItemProps {
  additionalCampaign: SingleProductPromotionAdditionalCampaign;
  staticText: StaticText;
  itemNumber: number | null;
  bulletColor: string;
}

export const CampaignItem: React.FC<CampaignItemProps> = ({
  additionalCampaign,
  staticText,
  itemNumber,
  bulletColor,
}) => {
  return (
    <div className="flex flex-col gap-spacing/gap/soft-8px">
      {itemNumber != null && (
        <h3 className="font-font-weight/title-2 text-font-size/title-2 leading-line-height/title-2 text-text/secondary">
          {`${itemNumber}. ${additionalCampaign.title}`}
        </h3>
      )}
      <p className="font-font-weight/body-2 text-font-size/body-2 leading-line-height/body-2-relaxed text-text/secondary">
        {staticText.yourApplicationQualifies}
      </p>
      <div className={`flex flex-col gap-spacing/gap/soft-12px ${bulletColor}`}>
        <div className="flex items-start gap-spacing/gap/soft-6px">
          <span className="w-[18px] shrink-0 text-center font-font-weight/bullet-1 text-font-size/bullet-1 leading-line-height/bullet-1">
            •
          </span>
          <span className="text-font-size/body-2">
            {additionalCampaign.linkUrl ? (
              <a
                href={additionalCampaign.linkUrl}
                target={
                  additionalCampaign.linkTarget === 'NEW_TAB'
                    ? '_blank'
                    : '_self'
                }
                rel={
                  additionalCampaign.linkTarget === 'NEW_TAB'
                    ? 'noopener noreferrer'
                    : undefined
                }
                className="leading-line-height/bullet-2"
              >
                <RawHtml content={additionalCampaign.rewardCopy} />
              </a>
            ) : (
              <RawHtml
                className="leading-line-height/bullet-2"
                content={additionalCampaign.rewardCopy}
              />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};
